// components/widgets/primitives/evidence-row.js
// ═══════════════════════════════════════════════════════════
// EVIDENCE ROW — inline source + claim row used to cite specific
// data points without nesting them in boxes.
// e.g.  "fmp · QQQ -0.38% pre-market"
// ═══════════════════════════════════════════════════════════

export default function EvidenceRow({ source, claim, className = '' }) {
  if (!source && !claim) return null;
  return (
    <div className={`ws-prim-evidence-row ${className}`}>
      {source && <span className="ws-prim-evidence-source">{source}</span>}
      {claim && <span className="ws-prim-evidence-claim">{claim}</span>}
    </div>
  );
}

export function EvidenceList({ items = [], className = '' }) {
  if (!items.length) return null;
  return (
    <div className={`ws-prim-evidence ${className}`}>
      {items.map((e, i) => (
        <EvidenceRow key={i} source={e.source} claim={e.claim} />
      ))}
    </div>
  );
}
